import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Calendário Cardápio",
  path: "/merenda/mercardapiodia",
  name: "mercardapiodia",
  component: () => import("@/views/merenda/mercardapiodia/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.CALENDARIOCARDAPIONOVO_MENU_1000200699],
  },
  goesToMenu: true,
 },
];
